const warningModalEquipService = {
  titleInactivate: 'Desactivar Servicio',
  textInactivate: 'Al Desactivar este servicio, ya no se utilizará en este tipo de equipo, no contará para el cálculo del estado y perderá sus servicios programados, pero se mantendrá su historial.',
  text2Inactivate: '¿Desea continuar?',
  confirmButtonTextInactivate: 'Desactivar SERVICIO',
  titleActivate: 'Habilitar Servicio',
  textActivate: 'Al habilitar este servicio, se utilizará para este tipo de equipo y contará para el cálculo del estado.',
  text2Activate: '¿Desea continuar?',
  confirmButtonTextActivate: 'HABILITAR SERVICIO',
};

export default warningModalEquipService;
